export interface RevenueCurrency {
	code: string
	symbol: string
	separatorBefore?: boolean
}

// Linear's revenue currency picker order: USD, EUR, GBP pinned, rest alphabetical. UAH is ours.
export const REVENUE_CURRENCIES: RevenueCurrency[] = [
	{ code: "USD", symbol: "$" },
	{ code: "EUR", symbol: "€" },
	{ code: "GBP", symbol: "£" },
	{ code: "AUD", symbol: "$", separatorBefore: true },
	{ code: "BRL", symbol: "R$" },
	{ code: "CAD", symbol: "$" },
	{ code: "CHF", symbol: "CHF" },
	{ code: "CNY", symbol: "¥" },
	{ code: "DKK", symbol: "kr" },
	{ code: "HKD", symbol: "$" },
	{ code: "INR", symbol: "₹" },
	{ code: "JPY", symbol: "¥" },
	{ code: "KRW", symbol: "₩" },
	{ code: "MXN", symbol: "$" },
	{ code: "NOK", symbol: "kr" },
	{ code: "NZD", symbol: "$" },
	{ code: "SEK", symbol: "kr" },
	{ code: "SGD", symbol: "$" },
	{ code: "TWD", symbol: "$" },
	{ code: "UAH", symbol: "₴" },
	{ code: "ZAR", symbol: "R" },
]

export const DEFAULT_REVENUE_CURRENCY = "USD"

export const REVENUE_CURRENCY_CODES = REVENUE_CURRENCIES.map((c) => c.code)

const BY_CODE = new Map(REVENUE_CURRENCIES.map((c) => [c.code, c]))

export function isSupportedRevenueCurrency(code: string | null | undefined) {
	return !!code && BY_CODE.has(code.toUpperCase())
}

export function getCurrencySymbol(code: string | null | undefined) {
	if (!code) {
		return BY_CODE.get(DEFAULT_REVENUE_CURRENCY)!.symbol
	}
	const currency = BY_CODE.get(code.toUpperCase())
	return currency ? currency.symbol : code.toUpperCase()
}

export function getRevenueCurrencyLabel(code: string | null | undefined) {
	const normalized = (code || DEFAULT_REVENUE_CURRENCY).toUpperCase()
	const currency = BY_CODE.get(normalized)
	return currency ? `${normalized} (${currency.symbol})` : normalized
}

export const REVENUE_CURRENCY_OPTIONS = REVENUE_CURRENCIES.map((currency) => ({
	value: currency.code,
	label: `${currency.code} (${currency.symbol})`,
	separatorBefore: currency.separatorBefore,
}))
